module.exports = __webpack_public_path__ + "img/bszn.5049e3d7.png";